import { Link } from "react-router-dom";

export const Logo = ({ to = "/", small = false }) => (
  <Link to={to} data-testid="brand-logo-link" className="group flex items-center gap-2.5">
    <span className="relative grid h-8 w-8 place-items-center rounded-md border border-emerald-500/40 bg-emerald-500/10">
      <span className="h-3 w-3 rotate-45 rounded-[2px] border-2 border-emerald-400 transition-transform duration-300 group-hover:rotate-[135deg]" />
    </span>
    <span className={`font-display font-semibold tracking-tight ${small ? "text-base" : "text-lg"}`}>
      Korevex<span className="text-emerald-400"> Bio</span>
    </span>
  </Link>
);
